/* SATHI RUGS: store visit requests. LINE opens a draft; customers send it themselves. */
(function () {
  'use strict';
  if (window.sathiVisitBooking) {
    window.sathiVisitBooking.init(document);
    return;
  }

  const stores = {
    yokohama: { name: 'SATHI RUGS 横浜 元町店', hours: '10:30〜18:30', phone: '045-264-8400', start: 630, end: 1110 },
    karuizawa: { name: 'Morris Rugs 軽井沢店', hours: '10:00〜19:00', phone: '0267-42-8450', start: 600, end: 1140 },
    tosu: { name: 'jahan 鳥栖店', hours: '10:00〜20:00', phone: '0942-85-8828', start: 600, end: 1200 }
  };
  const initialized = new WeakMap();

  // QR は PC の受け渡し画面でしか使わない（56KB）。必要になるまで読み込まない。
  let qrLoader = null;
  function loadQrLibrary(src) {
    if (typeof window.qrcode === 'function') return Promise.resolve(true);
    if (!src) return Promise.resolve(false);
    if (!qrLoader) {
      qrLoader = new Promise(resolve => {
        const script = document.createElement('script');
        script.src = src;
        script.addEventListener('load', () => resolve(typeof window.qrcode === 'function'));
        script.addEventListener('error', () => { qrLoader = null; resolve(false); });
        document.head.appendChild(script);
      });
    }
    return qrLoader;
  }
  const openInstances = new Set();
  const tokyoFormatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
  });
  let priorOverflow = '';

  function tokyoNow() {
    const p = {};
    tokyoFormatter.formatToParts(new Date()).forEach(part => { p[part.type] = part.value; });
    return { date: `${p.year}-${p.month}-${p.day}`, minute: Number(p.hour) * 60 + Number(p.minute) };
  }

  function lineUrl(account, message) {
    return `https://line.me/R/oaMessage/${encodeURIComponent(account)}/${message ? '?' + encodeURIComponent(message) : ''}`;
  }

  function formatTime(minutes) {
    return `${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`;
  }

  function bind(root) {
    if (initialized.has(root)) return;
    const dialog = root.querySelector('[data-svb-dialog]');
    const opener = root.querySelector('[data-svb-open]');
    const account = root.dataset.lineId;
    // PC版LINEは line.me/R/oaMessage 形式を開けないので、PCでは公式アカウントのページへ送る
    const accountPageUrl = /^@[^\s/?#]+$/.test(account || '') ? 'https://page.line.me/' + account.slice(1) : '';
    // PC では line.me/R/oaMessage 形式が使えず LINE の宣伝ページに飛ぶため、
    // 相談リンクだけは公式アカウントのページへ向け直す（売り切れ商品などダイアログが無い場合も動かす）
    const ask = root.querySelector('[data-svb-ask]');
    if (ask && !ask.dataset.svbAskReady && accountPageUrl) {
      // 画面幅ではなく端末で判定する。PCでウィンドウを狭めても oaMessage 形式に戻さない。
      if (!isHandheld()) ask.setAttribute('href', accountPageUrl);
      ask.dataset.svbAskReady = '1';
    }

    // Leave the original links usable when a browser cannot show native dialogs.
    if (!dialog || !opener || typeof dialog.showModal !== 'function' || !/^@[^\s/?#]+$/.test(account || '')) return;
    const $ = selector => root.querySelector(selector);
    const form = $('[data-svb-form]');
    const date = $('[data-svb-date]');
    const time = $('[data-svb-time]');
    const storeSelect = $('[data-svb-store]');
    const handoff = $('[data-svb-handoff]');
    const messageBox = $('[data-svb-message]');
    const qrBox = $('[data-svb-qr]');
    const intro = $('[data-svb-handoff-intro]');
    const copyStatus = $('[data-svb-copy-status]');
    const lineLink = $('[data-svb-line-link]');
    const controller = new AbortController();
    const on = (node, event, callback) => node.addEventListener(event, callback, { signal: controller.signal });
    let previousFocus = null;
    let lastMessage = '';
    let lastUrl = '';
    let qrToken = 0;
    let locked = false;
    let submittedState = null;
    const currentStoreKey = () => root.dataset.store || (storeSelect ? storeSelect.value : '');
    const currentStore = () => stores[currentStoreKey()];

    function lock() {
      if (locked) return;
      if (openInstances.size === 0) {
        priorOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
      locked = true;
      openInstances.add(root);
    }

    function unlock() {
      if (!locked) return;
      locked = false;
      openInstances.delete(root);
      if (openInstances.size === 0) document.body.style.overflow = priorOverflow;
    }

    function updateTimes() {
      const now = tokyoNow();
      date.min = now.date;
      const selected = time.value;
      const store = currentStore();
      time.replaceChildren(new Option('選択してください', ''));
      if (store) {
        for (let minute = store.start; minute < store.end; minute += 30) {
          const text = formatTime(minute);
          const option = new Option(text, text);
          option.disabled = date.value === now.date && minute <= now.minute;
          time.append(option);
        }
      }
      const valid = Array.from(time.options).find(option => option.value === selected && !option.disabled);
      time.value = valid ? selected : '';
      time.disabled = !store;
      date.setCustomValidity('');
      time.setCustomValidity('');
    }

    function updateStore() {
      const store = currentStore();
      $('[data-svb-store-summary]').hidden = !store;
      if (store) {
        $('[data-svb-store-name]').textContent = store.name;
        $('[data-svb-store-hours]').textContent = store.hours;
        const phone = $('[data-svb-store-phone]');
        phone.textContent = store.phone;
        phone.href = 'tel:' + store.phone.replaceAll('-', '');
      }
      updateTimes();
    }

    function showForm() {
      qrToken++; // 進行中のQR描画・コピー完了表示を無効にする
      // スマホは押せばLINEが開くので予告は不要。PCはQRが出るので先に伝える。
      const preNote = $('[data-svb-pre-note]');
      const confirmNote = $('[data-svb-confirm-note]');
      const handheld = isHandheld();
      if (preNote) {
        preNote.hidden = handheld;
        if (!handheld) preNote.textContent = 'このあとQRコードが出ます。スマートフォンで読み取り、LINEの送信ボタンを押してください。';
      }
      if (confirmNote) {
        confirmNote.innerHTML = (handheld ? 'LINEが開いたら、内容を確認して送信してください。<br>' : '')
          + 'ご相談やほかに見たい絨毯があれば、そのまま書き足せます。<br>店舗からの返信をもって、来店予約が確定します。';
      }
      form.hidden = false;
      handoff.hidden = true;
      $('[data-svb-title]').textContent = 'この絨毯を店頭で見る';
      $('[data-svb-eyebrow]').textContent = 'VISIT RESERVATION';
      copyStatus.textContent = '';
      updateStore();
      dialog.scrollTop = 0;
    }

    function validate() {
      const now = tokyoNow();
      date.min = now.date;
      date.setCustomValidity('');
      time.setCustomValidity('');
      const store = currentStore();
      if (date.value && date.value < now.date) date.setCustomValidity('本日以降の日付を選択してください。');
      const match = /^(\d{2}):(\d{2})$/.exec(time.value);
      if (match && store) {
        const minute = Number(match[1]) * 60 + Number(match[2]);
        if (minute < store.start || minute >= store.end || (minute - store.start) % 30 !== 0) {
          time.setCustomValidity('営業時間内の時間を選択してください。');
        } else if (date.value === now.date && minute <= now.minute) {
          time.setCustomValidity('現在より後の時間を選択してください。');
        }
      }
      if (!store) {
        if (storeSelect) storeSelect.reportValidity();
        return false;
      }
      return form.reportValidity();
    }

    function buildMessage() {
      const parts = date.value.split('-').map(Number);
      const lines = ['来店予約を希望します。', '', '商品：' + root.dataset.productTitle];
      if (root.dataset.productSku) lines.push('商品番号：' + root.dataset.productSku);
      lines.push('希望店舗：' + currentStore().name,
        `希望日時：${parts[0]}年${parts[1]}月${parts[2]}日 ${time.value}頃（日本時間）`);
      lines.push('', '商品ページ：', root.dataset.productUrl);
      return lines.join('\n');
    }

    // 世代番号は呼び出し側(showHandoff)が渡す。読み込み中に画面が進んでいたら描かない。
    async function renderQr(url, token) {
      qrBox.replaceChildren();
      qrBox.hidden = false;
      intro.textContent = 'スマートフォンでQRコードを読み取り、LINEで内容を確認して送信してください。';
      const ready = await loadQrLibrary(root.dataset.qrSrc);
      if (token !== qrToken || handoff.hidden) return;
      if (!ready) {
        qrBox.hidden = true;
        lineLink.hidden = false;
        intro.textContent = 'QRコードを表示できませんでした。下の文面をコピーし、「LINE公式ページを開く」からトークに貼り付けて送信してください。「希望日時を変更する」から戻って進み直すと、QRコードの表示をやり直せます。';
        return;
      }
      let qr;
      try {
        qr = window.qrcode(0, 'L');
        qr.addData(url);
        qr.make();
      } catch (_) {
        // Long optional notes may exceed QR capacity; keep all text available to copy.
        qr = window.qrcode(0, 'L');
        qr.addData(lineUrl(account, ''));
        qr.make();
        lineLink.hidden = false;
        intro.textContent = '文面が長いため、QRコードに予約内容を入れられませんでした。下の文面をコピーし、「LINE公式ページを開く」からトークに貼り付けて送信してください。';
      }
      qrBox.innerHTML = qr.createSvgTag({ cellSize: 3, margin: 12, scalable: true });
    }

    function showHandoff() {
      const token = ++qrToken; // この回の世代。古い非同期処理はこれで無効になる
      lastMessage = buildMessage();
      lastUrl = lineUrl(account, lastMessage);
      submittedState = { date: date.value, time: time.value, store: currentStoreKey() };
      messageBox.value = lastMessage;
      // PC版LINEは oaMessage 形式を開けないため、公式アカウントのページへ。
      lineLink.href = accountPageUrl || lastUrl;
      lineLink.textContent = accountPageUrl ? 'LINE公式ページを開く' : 'この端末のLINEで開く';
      lineLink.hidden = true; // QRが出せなかったときだけ出す(renderQrで解除)
      copyStatus.textContent = '';
      const qrHelp = $('[data-svb-qr-help]');
      {
        if (qrHelp) qrHelp.hidden = false;
        renderQr(lastUrl, token);
      }
      form.hidden = true;
      handoff.hidden = false;
      $('[data-svb-title]').textContent = 'LINEで来店希望を送る';
      $('[data-svb-eyebrow]').textContent = 'CONTINUE ON LINE';
      dialog.scrollTop = 0;
      intro.focus({ preventScroll: true });
    }

    // 画面幅ではなく端末の種類で判定する。PCでウィンドウを狭めてもスマホ扱いにしない。
    function isHandheld() {
      return window.matchMedia('(pointer: coarse)').matches && (navigator.maxTouchPoints || 0) > 0;
    }

    // iOS の長押しメニューを出さない（このボタンは遷移せずモーダルを開くため）
    on(opener, 'contextmenu', event => event.preventDefault());
    on(opener, 'click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      previousFocus = document.activeElement;
      showForm();
      dialog.showModal();
      lock();
    });
    on($('[data-svb-close]'), 'click', () => dialog.close());
    on(dialog, 'close', () => {
      unlock();
      if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
    });
    on(dialog, 'click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    if (storeSelect) on(storeSelect, 'change', updateStore);
    // 日付は placeholder 属性を持てないので、文言を重ねて値が入ったら隠す
    const dateWrap = root.querySelector('[data-svb-date-wrap]');
    const syncDatePh = () => { if (dateWrap) dateWrap.classList.toggle('is-filled', !!date.value); };
    on(date, 'input', syncDatePh);
    on(date, 'change', syncDatePh);
    syncDatePh();
    on(date, 'change', updateTimes);
    // PC はカレンダーのアイコンを押したときしか開かないので、欄のどこを押しても開くようにする。
    // タッチ端末は素のまま（タップで既に開くため、二重に呼ばない）。
    if (typeof date.showPicker === 'function') {
      on(date, 'click', () => {
        if (window.matchMedia('(pointer: coarse)').matches) return;
        try { date.showPicker(); } catch (_) { /* 既に開いている場合など */ }
      });
    }
    on(time, 'change', () => time.setCustomValidity(''));
    on(form, 'submit', event => {
      event.preventDefault();
      if (!validate()) return;
      if (isHandheld()) {
        // スマホは画面を切り替えない。入力を残したままLINEを開くので、
        // 戻ってきてもそのまま、開かなければ同じボタンでやり直せる。
        lastMessage = buildMessage();
        lastUrl = lineUrl(account, lastMessage);
        submittedState = { date: date.value, time: time.value, store: currentStoreKey() };
        window.location.assign(lastUrl);
        return;
      }
      showHandoff();
    });
    on(lineLink, 'click', event => {
      // A handoff page can be left open for hours; avoid requesting an elapsed time.
      if (submittedState && !validate()) {
        event.preventDefault();
        showForm();
        time.focus({ preventScroll: true });
        time.setCustomValidity('ご希望の日時をもう一度選択してください。');
        time.reportValidity();
      }
    });
    on($('[data-svb-back]'), 'click', () => { showForm(); date.focus({ preventScroll: true }); });
    on($('[data-svb-copy]'), 'click', async () => {
      // コピーの完了待ちの間に「戻る→日時変更→再送信」されると、
      // 古い文面の完了表示が新しい画面に出てしまうため、世代で弾く。
      const token = qrToken;
      const text = lastMessage;
      try {
        if (!navigator.clipboard || !window.isSecureContext) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(text);
        if (token !== qrToken) return;
        copyStatus.textContent = '文面をコピーしました。LINEに貼り付けて送信できます。';
      } catch (_) {
        if (token !== qrToken) return;
        messageBox.focus({ preventScroll: true });
        messageBox.select();
        copyStatus.textContent = '文面を選択しました。端末のコピー操作でコピーしてください。';
      }
    });
    updateStore();
    initialized.set(root, { destroy() {
      if (dialog.open) dialog.close();
      unlock();
      controller.abort();
      initialized.delete(root);
    } });
  }

  function init(scope) {
    if (scope.matches && scope.matches('[data-svb-root]')) bind(scope);
    scope.querySelectorAll('[data-svb-root]').forEach(bind);
  }
  window.sathiVisitBooking = { init };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-svb-root]').forEach(root => {
      const instance = initialized.get(root);
      if (instance) instance.destroy();
    });
  });
}());
